import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Calendar from "@/pages/Calendar";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import FAQ from "@/pages/FAQ";
import Documents from "@/pages/Documents";
import Contacts from "@/pages/Contacts";
import Contact from "@/pages/Contact";
import Inscriptions from "@/pages/Inscriptions";
import Trainings from "@/pages/Trainings";
import Stages from "@/pages/Stages";
import { GalleryIndex, AlbumView } from "@/pages/Gallery";
import Classements from "@/pages/Classements";
import Social from "@/pages/Social";
import Recrutement from "@/pages/Recrutement";
import LiveMatches from "@/pages/LiveMatches";
import Admin from "@/pages/Admin";
import AnalyticsTracker from "@/components/AnalyticsTracker";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/inscriptions" element={<Inscriptions />} />
            <Route path="/entrainements" element={<Trainings />} />
            <Route path="/stages" element={<Stages />} />
            <Route path="/galerie" element={<GalleryIndex />} />
            <Route path="/galerie/:slug" element={<AlbumView />} />
            <Route path="/calendrier" element={<Calendar />} />
            <Route path="/classements" element={<Classements />} />
            <Route path="/reseaux-sociaux" element={<Social />} />
            <Route path="/recrutement" element={<Recrutement />} />
            <Route path="/live-matchs" element={<LiveMatches />} />
            <Route path="/actualites" element={<News />} />
            <Route path="/actualites/:id" element={<NewsDetail />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
